<script setup>
import moment from "moment-timezone"
import ApiKeyIndex from "@/components/api-key/ApiKeyIndex.vue"
import ApiKeyImport from "@/components/api-key/ApiKeyImport.vue"
import ApiKeyExport from "@/components/api-key/ApiKeyExport.vue"

moment.tz.setDefault("Asia/Jakarta")

const loadingTable = ref()

definePage({
  meta: {
    layout: "default",
  },
})

const pageTitle = "API Key"

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "System",
    to: null,
  },
  {
    title: pageTitle,
    to: null,
  },
]


const route = useRoute()
const navigationTab = ref(route.query.export ? 2 : 0)
const tabItems = ["Search", "Import", "Export"]

</script>

<template>
  <VBreadcrumbs
    :items="breadCrumbs"
    class="px-0 pt-0 pb-5"
  />
  <h4 class="text-h4 my-4">
    Data {{ pageTitle }}
  </h4>
  <VCard>
    <VTabs v-model="navigationTab">
      <VTab
        v-for="item in tabItems"
        :key="item"
      >
        {{ item }}
      </VTab>
    </VTabs>
    <VWindow v-model="navigationTab">
      <VWindowItem :key="tabItems[0]">
        <ApiKeyIndex />
      </VWindowItem>
      <VWindowItem :key="tabItems[1]">
        <ApiKeyImport />
      </VWindowItem>
      <VWindowItem :key="tabItems[2]">
        <ApiKeyExport />
      </VWindowItem>
    </VWindow>
  </VCard>

</template>
